/* eslint-disable */
import React, { useEffect, useState } from "react";
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import * as API from "../../framework/API/api";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Grid, GridColumn as Column, GridColumn } from "@progress/kendo-react-grid";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import BossDialog from "../../components/BossDialog";
import ToastNotification from "../../components/ToastNotification";

const ClientEditForm = (props) => {

  const lang = useTranslation();
  const emailRegex = new RegExp(/\S+@\S+\.\S+/);

  const [dataItem, setDataItem] = useState({
    Name: "",
    Code: "",
    Email: "",
    CreditLimit: 0,
    PAN: "",
    GST: "",
    Agency: [],
    DefaultTax: {},
    IsCreditUnlimited: false,
    Archive: false,
    Address: "",
    PinCode: "",
    SalesTeam: {},
    SalesExecutive: [],
    SpotSeparation: '00:00:00:00',
    Location:""
  })

  const [defaultTax, setDefaultTax] = useState([]);
  const [salesTeam, setSalesTeam] = useState([]);
  const [agency, setAgency] = useState([]);
  const [salesExecutives, setSalesExecutives] = useState([]);

  useEffect(() => {
    pageRender();
  }, []);

  const pageRender = async () => {
    await loadcombo();
    if (props?.item?.SID > 0) {
      await loadEditData();
    }
  }

  const loadcombo = async () => {
    let defaultTax = await API.getDataLookup(ENTITYNAME.Tax, { sort: { Description: 1 } });
    setDefaultTax(defaultTax.data);
    let agency = await API.getDataLookup(ENTITYNAME.Agency, { sort: { Name: 1 } });
    setAgency(agency.data);
    let salesTeamRes = await API.getDataLookup(ENTITYNAME.SalesTeam, { sort: { Name: 1 } });
    setSalesTeam(salesTeamRes.data);
    if (props.item.SID == 0) {
      setDataItem({ ...dataItem, DefaultTax: utility.getDefaultItem(defaultTax.data) });
    }
  }

  const loadEditData = async () => {

    const linkData = {
      link_collection: 'users',
      link_field: 'SalesExecutive'
    }

    let res = await API.getEntity(ENTITYNAME.Client, props.item.SID, linkData);
    console.log(res.data);
    if (res.success) {
      setDataItem({
        ...dataItem, ...res.data,
        Name: props?.item?.copy ? 'Copy of ' + res.data.Name : res.data.Name,
        SpotSeparation: res.data.SpotSeparation == null ? "00:00:00:00" : utility.convertMilisecondsToStringWithFrames(res.data.SpotSeparation),
        Agency: Array.isArray(res.data.Agency) ? res.data.Agency : [res.data.Agency],
        SalesExecutive: Array.isArray(res.data.SalesExecutive) ? res.data.SalesExecutive : [res.data.SalesExecutive] ?? [],
      })
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const loadSalesExecutives = async (salesTeamSID) => {
    if (!salesTeamSID) {
      setSalesExecutives([]);
      return;
    }

    const salesExecutiveRes = await API.getData(ENTITYNAME.Users,{sort: { Description: 1 },query: [['IsSalesExecutive', '=', true],['SalesTeam.SID', '=', salesTeamSID]]});
    setSalesExecutives(salesExecutiveRes.data || []);
  };

  const onChange = async (e) => {
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else if (e.target.name == "IsCreditUnlimited") {
      setDataItem({ ...dataItem, IsCreditUnlimited: !dataItem.IsCreditUnlimited, CreditLimit: 0 });
    }  else if (e.target.name == "SalesTeam") {
      setDataItem({...dataItem,SalesTeam: e.target.value,SalesExecutive: []});
    await loadSalesExecutives(e.target.value?.SID);
  } 
    else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  }

  const isValid = () => {

    if (!dataItem.Name || dataItem.Name == "" || !dataItem.Name.trim()) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
      return false;
    }
    if (!dataItem.Code || dataItem.Code == "" || !dataItem.Code.trim()) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_code_error_message });
      return false;
    }
    if (dataItem.Email == undefined || dataItem.Email == "" || !emailRegex.test(dataItem.Email)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_email_error_message });
      return false;
    }
    if (!dataItem.DefaultTax || Object.keys(dataItem.DefaultTax).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_default_tax_error_message });
      return false;
    }
    if (dataItem.CreditLimit < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_positive_value_in_creditlimit_error_message });
      return false;
    }
    if (!dataItem.SalesTeam || Object.keys(dataItem.SalesTeam).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_sales_team_error_message });
      return false;
    }
    if (dataItem.Agency?.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_agency_error_message });
      return false;
    }
    if (dataItem.SalesExecutive?.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_Sales_executive });
      return false;
    }
    return true;
  }

  const handleSubmit = async () => {

    if (!isValid()) return;

    let localData = {
      _id: dataItem._id,
      SID: props?.item?.copy ? 0 : dataItem.SID,
      Name: dataItem.Name,
      Code: dataItem.Code,
      Agency: dataItem.Agency && dataItem.Agency.length > 0 ? dataItem.Agency.map((x) => {
        return { _id: x._id, SID: x.SID, Name: x.Name, DefaultTax: x.DefaultTax }
      }) : [],
      Address: dataItem.Address,
      PinCode: dataItem.PinCode,
      Email: dataItem.Email,
      PAN: dataItem.PAN,
      GST: dataItem.GST,
      DefaultTax: {
        _id: dataItem.DefaultTax._id,
        SID: dataItem.DefaultTax.SID,
        Description: dataItem.DefaultTax.Description
      },
      CreditLimit: !dataItem.IsCreditUnlimited ? parseInt(dataItem.CreditLimit) : 0,
      SalesTeam: {
        _id: dataItem.SalesTeam._id,
        SID: dataItem.SalesTeam.SID,
        Name: dataItem.SalesTeam.Name
      },
      SalesExecutive: dataItem?.SalesExecutive?.length > 0 ? dataItem?.SalesExecutive?.map(x => x._id) : [],
      SpotSeparation: dataItem.SpotSeparation ? utility.convertStringWithFramesToMilliseconds(dataItem?.SpotSeparation) : "",
      IsCreditUnlimited: dataItem.IsCreditUnlimited ?? false,
      ClientType: dataItem.ClientType,
      AddressCode: dataItem.AddressCode,
      Archive: dataItem.Archive ?? false,
      checkDuplicate: true,
      Location: dataItem.Location,
      query: [["Name", "=", dataItem.Name]]
    }

    if (props?.item?.copy) {
      delete localData.SID;
      delete localData._id;
    }
    console.log(localData);
    let res = await API.saveData(ENTITYNAME.Client, localData);

    if (res.success) {
      let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE_CLIENT : LOGEVENT.INSERT_CLIENT, module: MODULE.CLIENT, data: res.data, message: res.message };
      API.SaveLogs(logData);
      utility.deleteLocalStorageItem(ENTITYNAME.Client);
      props.cancelEdit();
      props.refresh();
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }


  return (<>

    <BossDialog title={props?.item?.Name ? props?.item?.Name : lang.client_dialog_header}
      onClose={props.cancelEdit}
      width={"65vw"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <div className="row mt-2">
        <div className="col-12">
          <div className="row form-group">
            <div className="col-3">
              <label htmlFor="TabView">{lang.name_label} *</label>
              <input className="form-control form-control-sm" type="text" name={"Name"} onChange={onChange} value={dataItem.Name} />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.code_label} *</label>
              <input className="form-control form-control-sm" type="text" name={"Code"} onChange={onChange} value={dataItem.Code} />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.client_type_label}</label>
              <input className="form-control form-control-sm" type="text" name="ClientType" onChange={onChange} value={dataItem.ClientType} />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.email_label} *</label>
              <input className="form-control form-control-sm" type="email" name={"Email"} value={dataItem.Email} onChange={onChange} />
            </div>
          </div>
          <div className="row form-group">

            <div className="col-3">
              <label htmlFor="TabView">{lang.address_label}</label>
              <input className="form-control form-control-sm" type="text" name={"Address"} onChange={onChange} value={dataItem.Address} />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.address_code_label}</label>
              <input className="form-control form-control-sm" type="text" name="AddressCode" onChange={onChange} value={dataItem.AddressCode} />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.pincode_label}</label>
              <input className="form-control form-control-sm" type="number" name={"PinCode"} onChange={onChange} value={dataItem.PinCode} />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.location_label}</label>
              <input className="form-control form-control-sm" type="text" name="Location" onChange={onChange} value={dataItem.Location} />
            </div>
          </div>
          <div className="row form-group">
          </div>
          <div className="row form-group">
            <div className="col-3">
              <label htmlFor="TabView">{lang.pan_label}</label>
              <input className="form-control form-control-sm" type="text" name={"PAN"} value={dataItem.PAN} onChange={onChange} />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.default_tax_label} *</label>
              <DropDownList
                style={{
                  backgroundColor: "white",
                }}
                data={defaultTax}
                name="DefaultTax"
                textField="Description"
                dataItemKey="_id"
                value={dataItem.DefaultTax}
                onChange={onChange}
              />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.gst_trn_label}</label>
              <input className="form-control form-control-sm" name={"GST"} type="text" onChange={onChange} value={dataItem.GST} />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.credit_limit_label} *</label>
              <span className="float-right">
                <input
                  type="checkbox"
                  name="IsCreditUnlimited"
                  value={dataItem.IsCreditUnlimited}
                  checked={dataItem.IsCreditUnlimited}
                  onChange={onChange}
                />
                <label className="ml-1">{lang.is_credit_unlimited_label}</label>
              </span>
              <div className="form-group">
                <input
                  className="form-control form-control-sm"
                  disabled={dataItem.IsCreditUnlimited}
                  type="number"
                  name="CreditLimit"
                  onChange={onChange}
                  value={dataItem.CreditLimit}
                  min={0}
                />
              </div>
            </div>
          </div>
          <div className="row form-group">
            <div className='col-3'>
              <label>{lang.spot_separation_label}</label>
              <TimePickerWithFormat
                className="form-control form-control-sm"
                name="SpotSeparation"
                value={dataItem.SpotSeparation}
                onChange={onChange}
              />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.sales_team_label} *</label>
              <DropDownList
                style={{
                  backgroundColor: "white",
                }}
                data={salesTeam}
                name="SalesTeam"
                textField="Name"
                dataItemKey="_id"
                value={dataItem.SalesTeam}
                onChange={onChange}
              />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.agency_label} *</label>
              <MultiSelect
                style={{
                  backgroundColor: "white",
                }}
                data={agency}
                name="Agency"
                textField="Name"
                dataItemKey="_id"
                value={dataItem.Agency}
                onChange={onChange}
              />
            </div>
            <div className="col-3">
              <label htmlFor="TabView">{lang.sales_executive_label} *</label>
              <MultiSelect
                style={{
                  backgroundColor: "white",
                }}
                data={salesExecutives}
                name="SalesExecutive"
                textField="name"
                dataItemKey="_id"
                value={dataItem.SalesExecutive}
                onChange={onChange}
              />
            </div>
            <div className="col mt-4 ml-2">
              <input type="checkbox" name={"Archive"} value={dataItem.Archive} checked={dataItem.Archive} onChange={onChange} />
              <label className="pl-2" htmlFor="TabView">{lang.archive}</label>
            </div>
          </div>
        </div>
      </div>
    </BossDialog>
  </>)
}

export default ClientEditForm;